import { useEffect } from "react";

// Applies the styles found in a free-text HTML snippet (e.g. entered in the config application)
// while the calling page is mounted.
// Only <link rel="stylesheet"> and <style> are honoured, anything else in the snippet is ignored.
export const useCustomHeadStyles = (html?: string | null): void => {
  useEffect(() => {
    if (!html) return;

    const parsedDoc = new DOMParser().parseFromString(html, "text/html");
    const headElems: HTMLElement[] = [];

    parsedDoc.querySelectorAll("link[href], style").forEach((elem) => {
      if (elem.tagName === "STYLE") {
        const styleElem = document.createElement("style");

        styleElem.textContent = elem.textContent;

        headElems.push(styleElem);

        return;
      }

      if (!/(^|\s)stylesheet(\s|$)/i.test(elem.getAttribute("rel") || "")) return;

      let url: URL;

      try {
        url = new URL(elem.getAttribute("href") || "", window.location.origin);
      } catch {
        return;
      }

      // Only https or same origin stylesheets
      if (url.protocol !== "https:" && url.origin !== window.location.origin) return;

      const linkElem = document.createElement("link");

      linkElem.rel = "stylesheet";
      linkElem.href = url.href;

      headElems.push(linkElem);
    });

    headElems.forEach((headElem) => document.head.appendChild(headElem));

    return () => {
      headElems.forEach((headElem) => headElem.remove());
    };
  }, [html]);
};
